import React, { useEffect, useState } from "react";
import { postContentReport } from "../../services/api/user/postContentReport";
import { genPageName, PageTypes } from "../../utils/PageTypes";
import { RequestState } from "../../utils/RequestState";
import ContentReportModal from "./ContentReportModal";

type Props = {
  isModalShown: boolean;
  closeHandler: () => void;
  pageType: PageTypes;
  contentName?: string;
};
const ContentReportModalContainer: React.FC<Props> = ({
  isModalShown,
  closeHandler,
  pageType,
  contentName,
}) => {
  useEffect(() => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = isModalShown ? "hidden" : "unset";
    }

    return () => {
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, [isModalShown]);

  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const submitHandler = async (contentReport: string) => {
    // 報告内容を確認
    if (!contentReport.length) return;

    // ダブルクリック防止
    if (requestState === RequestState.Doing) return;

    // 送信処理
    setRequestState(RequestState.Doing);

    const res = await postContentReport(
      genPageName(pageType),
      window.location.href,
      contentReport,
      contentName
    );

    if (!res) {
      return setRequestState(RequestState.Failed);
    }

    setRequestState(RequestState.Success);
  };

  if (!isModalShown) {
    return null;
  }

  return (
    <ContentReportModal
      pageType={pageType}
      contentName={contentName}
      requestState={requestState}
      submitHandler={submitHandler}
      closeHandler={() => {
        closeHandler();
        setRequestState(RequestState.Waiting);
      }}
    />
  );
};

export default ContentReportModalContainer;
